<template lang="pug">
div
  v-card(flat)
    v-card-title Financial Information
    keep-alive
      validation-observer(
        ref="o04",
        v-slot="{ invalid }",
        :persist="true",
        vid="o04"
      )
        v-container
          v-row(v-if="SEA_PreviouslyHeld === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 What was the PREVIOUS total gross revenue of the event the last time it was held?
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  prefix="$"
                  v-model="SEA_PreviousGrossRevenue",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_PreviouslyHeld === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 What was the PREVIOUS total expense of the the last time it was held?
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  prefix="$"
                  v-model="SEA_PreviousCost",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}

          v-row(v-if="SEA_PreviouslyHeld === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 PREVIOUS Public Safety Charges
              p.pb-0.pl-8.text--secondary If the event incurred Arlington County public safety charges previously, what was the total amount of the charges?
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  prefix="$"
                  v-model="SEA_PreviousCharges",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 What is the estimated total gross revenue for the event this year?
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  prefix="$"
                  v-model="SEA_EstimatedGrossRevenue",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 What is the estimated total expense for the event this year?
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  prefix="$"
                  v-model="SEA_EstimatedTotalExpense",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Nonprofit == 'Yes, other'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Do you wish to apply for a Special Event Fee Reduction Award for Nonprofits?
              p.pb-0.pl-8.text--secondary Fee reductions are awarded annually to <a href="http://law.lis.virginia.gov/vacode/15.2-953/" target="_blank">qualified nonprofit organizations</a> (such as partnerships, heritage groups and other community groups) to offset costs for required law enforcement, fire and emergency response personnel services. Fee reduction awards are limited to the actual County public safety charges related to required services for the event. Eligible nonprofit organization may receive a maximum of two fee reduction awards per County fiscal year. Fee reduction awards are a maximum of $4,000, per event, if the event is approved.
              v-radio-group(v-model="SEA_FeeReductionAward" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_PreviousGrossRevenue",
      "data.SEA_PreviousCost",
      "data.SEA_PreviousCharges",
      "data.SEA_EstimatedGrossRevenue",
      "data.SEA_EstimatedTotalExpense",
      "data.SEA_PreviouslyHeld",
      "data.SEA_FeeReductionAward",
      "data.SEA_Nonprofit",
      "data.disabled",
    ]),
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
};
</script>